module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.56d58d4b.svg";